import type { ReactNode } from 'react'
import { BrowserRouter } from 'react-router'

export const withRouter = (component: () => ReactNode) => () =>
  <BrowserRouter>{component()}</BrowserRouter>
